import { FEATURE_DESCRIPTION_MAP } from './featureDescriptionMap';
import { FEATURE_DISPLAY_NAME_MAP } from './featureDisplayNameMap';
import { FEATURE_PRODUCT_MAP } from './featureProductMap';
import { FEATURE_SHORT_LIMIT_MAP } from './featureShortLimitMap';
import { ABM_TOOLS_AND_AUTOMATION, ADVANCED_LIST_CRITERIA, ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING, AI_FORECASTING, AI_MEETING_ASSISTANT, ASSOCIATION_LABELS, AUTOMATIC_LEAD_ROTATION, B2B_CHECKOUT, BOOK_ON_BEHALF_OF_OTHERS, BREEZE_COPILOT, BREEZE_PROSPECTING_AGENT, CALCULATED_PROPERTIES, CALLING, CHANNEL_SWITCHING, COACHING_PLAYLISTS, CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS, CONVERSATIONAL_BOTS, CONVERSATION_INTELLIGENCE, CONVERSATION_ROUTING, CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING, CUSTOM_DEAL_TAG_RULES, CUSTOM_EVENTS, CUSTOM_GOALS, CUSTOM_OBJECTS, CUSTOM_PERMISSION_SETS, CUSTOM_PROPERTIES, CUSTOM_REPORT_BUILDER, CUSTOM_USER_PERMISSIONS, CUSTOM_VIEWS, DATA_MODEL, DEALS, DEAL_APPROVALS, DEAL_JOURNEY_ANALYTICS, DEAL_PIPELINE_AUTOMATION, DEAL_SPLITS, DEAL_SUMMARIES, DEAL_TAGS, DOCUMENTS, DRAGGABLE_CHAT_WIDGET, DUPLICATE_MANAGEMENT, DYNAMIC_SEQUENCES, EMAIL_AND_IN_APP_CHAT, EMAIL_TEMPLATES, EMAIL_TRACKING_AND_NOTIFICATIONS, EMBED_AND_UPDATE_PROPERTIES, E_SIGNATURE, FACEBOOK_MESSENGER_INTEGRATION, FIELD_LEVEL_PERMISSIONS, FORECASTING, FORECAST_ACROSS_TEAM_HIERARCHIES, GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS, GOALS, GUIDED_ACTIONS, HUBSPOT_MOBILE_APP, HUBSPOT_PROVIDED_PHONE_NUMBERS, INTERACTIVE_VOICE_RESPONSE, INVOICES, LEADS, LEAD_FORM_ROUTING, LINKEDIN_CRM_SYNC_INTEGRATION, LINKEDIN_SALES_NAVIGATOR_INTEGRATION, LISTS, LIVE_CHAT, LOGGED_IN_VISITOR_IDENTIFICATION, LOG_IN_AS_ANOTHER_USER, MEETING_SCHEDULER, MOBILE_INBOX, MULTIPLE_CURRENCIES, MULTIPLE_EMAIL_SIGNATURES, ONE_TO_ONE_EMAIL, ONE_TO_ONE_TECHNICAL_SUPPORT, ONE_TO_ONE_VIDEO_MESSAGING, ORGANIZE_TEAMS, PAYMENTS, PAYMENT_LINKS, PERMISSION_SETS, PHONE_SUPPORT, PLAYBOOKS, PREDICTIVE_LEAD_SCORING, PRESETS, PRODUCTS, QUOTES, REPEATING_TASKS_AND_QUEUES, REPORTING_DASHBOARDS, SALESFORCE_CUSTOM_OBJECT_SYNC, SALESFORCE_INTEGRATION, SALES_ANALYTICS, SALES_CONTENT_ANALYTICS, SALES_EMAIL_FREQUENCY_CONTROLS, SALES_WORKSPACE, SCORE_PROPERTIES, SENSITIVE_DATA, SEQUENCES, SHARED_INBOX, SINGLE_SIGN_ON, SLACK_INTEGRATION, SNIPPETS, STANDARD_SANDBOX_ACCOUNT, STRIPE_PAYMENT_PROCESSING, SUBSCRIPTIONS, SYNC_PROPERTIES, TARGET_ACCOUNTS, TARGET_ACCOUNTS_OVERVIEW, TASKS, TASK_CALENDAR_SYNC, TEAMS, TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS, TRACKED_TERMS, TRIGGER_SEQUENCES, USER_MANAGEMENT, WORKFLOWS, WORKFLOW_EXTENSIONS, WORKFLOW_HEALTH_MONITORING } from './features';

// We aren't using longLimits in this experiment.
// The current type requests <Record<string, string>>, but should really be <Record<string, string | null>>.
const DEFAULT_LONG_NULL_LIMITS = {
  'sales-hub-free': 'null',
  'sales-hub-starter': 'null',
  'sales-hub-professional': 'null',
  'sales-hub-enterprise': 'null'
};

// We're using hardcoded FE values for descriptions, so hardcoding this for now.
const DEFAULT_SHOULD_USE_DEFAULT_LIMITS = {
  'sales-hub-free': true,
  'sales-hub-starter': true,
  'sales-hub-professional': true,
  'sales-hub-enterprise': true
};

// These are values we won't be using for the experiment, but need for the type. May change to casting type
const DEFAULT_VALUES = {
  featureId: 0,
  hideFromLang: null,
  isLive: true,
  featureCategory: 'UNCATEGORIZED',
  featureStatus: 'CLONED_TO_PROD',
  freeUserAccessLevel: 'FULL_ACCESS',
  longLimits: DEFAULT_LONG_NULL_LIMITS,
  shouldUseDefaultLimits: DEFAULT_SHOULD_USE_DEFAULT_LIMITS
};
export const FEATURE_DATA = {
  [ONE_TO_ONE_EMAIL]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[ONE_TO_ONE_EMAIL],
    productApiNames: FEATURE_PRODUCT_MAP[ONE_TO_ONE_EMAIL],
    descriptions: FEATURE_DESCRIPTION_MAP[ONE_TO_ONE_EMAIL],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[ONE_TO_ONE_EMAIL],
    shortName: ONE_TO_ONE_EMAIL
  }, DEFAULT_VALUES),
  [CHANNEL_SWITCHING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CHANNEL_SWITCHING],
    productApiNames: FEATURE_PRODUCT_MAP[CHANNEL_SWITCHING],
    descriptions: FEATURE_DESCRIPTION_MAP[CHANNEL_SWITCHING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CHANNEL_SWITCHING],
    shortName: CHANNEL_SWITCHING
  }, DEFAULT_VALUES),
  [GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS],
    productApiNames: FEATURE_PRODUCT_MAP[GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS],
    descriptions: FEATURE_DESCRIPTION_MAP[GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS],
    shortName: GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS
  }, DEFAULT_VALUES),
  [EMAIL_TRACKING_AND_NOTIFICATIONS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[EMAIL_TRACKING_AND_NOTIFICATIONS],
    productApiNames: FEATURE_PRODUCT_MAP[EMAIL_TRACKING_AND_NOTIFICATIONS],
    descriptions: FEATURE_DESCRIPTION_MAP[EMAIL_TRACKING_AND_NOTIFICATIONS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[EMAIL_TRACKING_AND_NOTIFICATIONS],
    shortName: EMAIL_TRACKING_AND_NOTIFICATIONS
  }, DEFAULT_VALUES),
  [ONE_TO_ONE_VIDEO_MESSAGING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[ONE_TO_ONE_VIDEO_MESSAGING],
    productApiNames: FEATURE_PRODUCT_MAP[ONE_TO_ONE_VIDEO_MESSAGING],
    descriptions: FEATURE_DESCRIPTION_MAP[ONE_TO_ONE_VIDEO_MESSAGING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[ONE_TO_ONE_VIDEO_MESSAGING],
    shortName: ONE_TO_ONE_VIDEO_MESSAGING
  }, DEFAULT_VALUES),
  [MULTIPLE_EMAIL_SIGNATURES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[MULTIPLE_EMAIL_SIGNATURES],
    productApiNames: FEATURE_PRODUCT_MAP[MULTIPLE_EMAIL_SIGNATURES],
    descriptions: FEATURE_DESCRIPTION_MAP[MULTIPLE_EMAIL_SIGNATURES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[MULTIPLE_EMAIL_SIGNATURES],
    shortName: MULTIPLE_EMAIL_SIGNATURES
  }, DEFAULT_VALUES),
  [EMAIL_TEMPLATES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[EMAIL_TEMPLATES],
    productApiNames: FEATURE_PRODUCT_MAP[EMAIL_TEMPLATES],
    descriptions: FEATURE_DESCRIPTION_MAP[EMAIL_TEMPLATES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[EMAIL_TEMPLATES],
    shortName: EMAIL_TEMPLATES
  }, DEFAULT_VALUES),
  [SALES_CONTENT_ANALYTICS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SALES_CONTENT_ANALYTICS],
    productApiNames: FEATURE_PRODUCT_MAP[SALES_CONTENT_ANALYTICS],
    descriptions: FEATURE_DESCRIPTION_MAP[SALES_CONTENT_ANALYTICS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SALES_CONTENT_ANALYTICS],
    shortName: SALES_CONTENT_ANALYTICS
  }, DEFAULT_VALUES),
  [LIVE_CHAT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[LIVE_CHAT],
    productApiNames: FEATURE_PRODUCT_MAP[LIVE_CHAT],
    descriptions: FEATURE_DESCRIPTION_MAP[LIVE_CHAT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[LIVE_CHAT],
    shortName: LIVE_CHAT
  }, DEFAULT_VALUES),
  [LOGGED_IN_VISITOR_IDENTIFICATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[LOGGED_IN_VISITOR_IDENTIFICATION],
    productApiNames: FEATURE_PRODUCT_MAP[LOGGED_IN_VISITOR_IDENTIFICATION],
    descriptions: FEATURE_DESCRIPTION_MAP[LOGGED_IN_VISITOR_IDENTIFICATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[LOGGED_IN_VISITOR_IDENTIFICATION],
    shortName: LOGGED_IN_VISITOR_IDENTIFICATION
  }, DEFAULT_VALUES),
  [DRAGGABLE_CHAT_WIDGET]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DRAGGABLE_CHAT_WIDGET],
    productApiNames: FEATURE_PRODUCT_MAP[DRAGGABLE_CHAT_WIDGET],
    descriptions: FEATURE_DESCRIPTION_MAP[DRAGGABLE_CHAT_WIDGET],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DRAGGABLE_CHAT_WIDGET],
    shortName: DRAGGABLE_CHAT_WIDGET
  }, DEFAULT_VALUES),
  [CONVERSATIONAL_BOTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CONVERSATIONAL_BOTS],
    productApiNames: FEATURE_PRODUCT_MAP[CONVERSATIONAL_BOTS],
    descriptions: FEATURE_DESCRIPTION_MAP[CONVERSATIONAL_BOTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CONVERSATIONAL_BOTS],
    shortName: CONVERSATIONAL_BOTS
  }, DEFAULT_VALUES),
  [TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS],
    productApiNames: FEATURE_PRODUCT_MAP[TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS],
    descriptions: FEATURE_DESCRIPTION_MAP[TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS],
    shortName: TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS
  }, DEFAULT_VALUES),
  [CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING],
    shortName: CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING
  }, DEFAULT_VALUES),
  [FACEBOOK_MESSENGER_INTEGRATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[FACEBOOK_MESSENGER_INTEGRATION],
    productApiNames: FEATURE_PRODUCT_MAP[FACEBOOK_MESSENGER_INTEGRATION],
    descriptions: FEATURE_DESCRIPTION_MAP[FACEBOOK_MESSENGER_INTEGRATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[FACEBOOK_MESSENGER_INTEGRATION],
    shortName: FACEBOOK_MESSENGER_INTEGRATION
  }, DEFAULT_VALUES),
  [ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING],
    productApiNames: FEATURE_PRODUCT_MAP[ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING],
    descriptions: FEATURE_DESCRIPTION_MAP[ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING],
    shortName: ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING
  }, DEFAULT_VALUES),
  [CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS],
    productApiNames: FEATURE_PRODUCT_MAP[CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS],
    descriptions: FEATURE_DESCRIPTION_MAP[CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS],
    shortName: CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS
  }, DEFAULT_VALUES),
  [MEETING_SCHEDULER]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[MEETING_SCHEDULER],
    productApiNames: FEATURE_PRODUCT_MAP[MEETING_SCHEDULER],
    descriptions: FEATURE_DESCRIPTION_MAP[MEETING_SCHEDULER],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[MEETING_SCHEDULER],
    shortName: MEETING_SCHEDULER
  }, DEFAULT_VALUES),
  [AI_MEETING_ASSISTANT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[AI_MEETING_ASSISTANT],
    productApiNames: FEATURE_PRODUCT_MAP[AI_MEETING_ASSISTANT],
    descriptions: FEATURE_DESCRIPTION_MAP[AI_MEETING_ASSISTANT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[AI_MEETING_ASSISTANT],
    shortName: AI_MEETING_ASSISTANT
  }, DEFAULT_VALUES),
  [BOOK_ON_BEHALF_OF_OTHERS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[BOOK_ON_BEHALF_OF_OTHERS],
    productApiNames: FEATURE_PRODUCT_MAP[BOOK_ON_BEHALF_OF_OTHERS],
    descriptions: FEATURE_DESCRIPTION_MAP[BOOK_ON_BEHALF_OF_OTHERS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[BOOK_ON_BEHALF_OF_OTHERS],
    shortName: BOOK_ON_BEHALF_OF_OTHERS
  }, DEFAULT_VALUES),
  [LEAD_FORM_ROUTING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[LEAD_FORM_ROUTING],
    productApiNames: FEATURE_PRODUCT_MAP[LEAD_FORM_ROUTING],
    descriptions: FEATURE_DESCRIPTION_MAP[LEAD_FORM_ROUTING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[LEAD_FORM_ROUTING],
    shortName: LEAD_FORM_ROUTING
  }, DEFAULT_VALUES),
  [SHARED_INBOX]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SHARED_INBOX],
    productApiNames: FEATURE_PRODUCT_MAP[SHARED_INBOX],
    descriptions: FEATURE_DESCRIPTION_MAP[SHARED_INBOX],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SHARED_INBOX],
    shortName: SHARED_INBOX
  }, DEFAULT_VALUES),
  [CONVERSATION_ROUTING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CONVERSATION_ROUTING],
    productApiNames: FEATURE_PRODUCT_MAP[CONVERSATION_ROUTING],
    descriptions: FEATURE_DESCRIPTION_MAP[CONVERSATION_ROUTING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CONVERSATION_ROUTING],
    shortName: CONVERSATION_ROUTING
  }, DEFAULT_VALUES),
  [CUSTOM_VIEWS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_VIEWS],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_VIEWS],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_VIEWS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_VIEWS],
    shortName: CUSTOM_VIEWS
  }, DEFAULT_VALUES),
  [SNIPPETS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SNIPPETS],
    productApiNames: FEATURE_PRODUCT_MAP[SNIPPETS],
    descriptions: FEATURE_DESCRIPTION_MAP[SNIPPETS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SNIPPETS],
    shortName: SNIPPETS
  }, DEFAULT_VALUES),
  [TASKS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[TASKS],
    productApiNames: FEATURE_PRODUCT_MAP[TASKS],
    descriptions: FEATURE_DESCRIPTION_MAP[TASKS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[TASKS],
    shortName: TASKS
  }, DEFAULT_VALUES),
  [TASK_CALENDAR_SYNC]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[TASK_CALENDAR_SYNC],
    productApiNames: FEATURE_PRODUCT_MAP[TASK_CALENDAR_SYNC],
    descriptions: FEATURE_DESCRIPTION_MAP[TASK_CALENDAR_SYNC],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[TASK_CALENDAR_SYNC],
    shortName: TASK_CALENDAR_SYNC
  }, DEFAULT_VALUES),
  [REPEATING_TASKS_AND_QUEUES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[REPEATING_TASKS_AND_QUEUES],
    productApiNames: FEATURE_PRODUCT_MAP[REPEATING_TASKS_AND_QUEUES],
    descriptions: FEATURE_DESCRIPTION_MAP[REPEATING_TASKS_AND_QUEUES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[REPEATING_TASKS_AND_QUEUES],
    shortName: REPEATING_TASKS_AND_QUEUES
  }, DEFAULT_VALUES),
  [CALLING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CALLING],
    productApiNames: FEATURE_PRODUCT_MAP[CALLING],
    descriptions: FEATURE_DESCRIPTION_MAP[CALLING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CALLING],
    shortName: CALLING
  }, DEFAULT_VALUES),
  [HUBSPOT_PROVIDED_PHONE_NUMBERS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[HUBSPOT_PROVIDED_PHONE_NUMBERS],
    productApiNames: FEATURE_PRODUCT_MAP[HUBSPOT_PROVIDED_PHONE_NUMBERS],
    descriptions: FEATURE_DESCRIPTION_MAP[HUBSPOT_PROVIDED_PHONE_NUMBERS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[HUBSPOT_PROVIDED_PHONE_NUMBERS],
    shortName: HUBSPOT_PROVIDED_PHONE_NUMBERS
  }, DEFAULT_VALUES),
  [INTERACTIVE_VOICE_RESPONSE]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[INTERACTIVE_VOICE_RESPONSE],
    productApiNames: FEATURE_PRODUCT_MAP[INTERACTIVE_VOICE_RESPONSE],
    descriptions: FEATURE_DESCRIPTION_MAP[INTERACTIVE_VOICE_RESPONSE],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[INTERACTIVE_VOICE_RESPONSE],
    shortName: INTERACTIVE_VOICE_RESPONSE
  }, DEFAULT_VALUES),
  [BREEZE_PROSPECTING_AGENT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[BREEZE_PROSPECTING_AGENT],
    productApiNames: FEATURE_PRODUCT_MAP[BREEZE_PROSPECTING_AGENT],
    descriptions: FEATURE_DESCRIPTION_MAP[BREEZE_PROSPECTING_AGENT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[BREEZE_PROSPECTING_AGENT],
    shortName: BREEZE_PROSPECTING_AGENT
  }, DEFAULT_VALUES),
  [LINKEDIN_SALES_NAVIGATOR_INTEGRATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[LINKEDIN_SALES_NAVIGATOR_INTEGRATION],
    productApiNames: FEATURE_PRODUCT_MAP[LINKEDIN_SALES_NAVIGATOR_INTEGRATION],
    descriptions: FEATURE_DESCRIPTION_MAP[LINKEDIN_SALES_NAVIGATOR_INTEGRATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[LINKEDIN_SALES_NAVIGATOR_INTEGRATION],
    shortName: LINKEDIN_SALES_NAVIGATOR_INTEGRATION
  }, DEFAULT_VALUES),
  [SALES_WORKSPACE]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SALES_WORKSPACE],
    productApiNames: FEATURE_PRODUCT_MAP[SALES_WORKSPACE],
    descriptions: FEATURE_DESCRIPTION_MAP[SALES_WORKSPACE],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SALES_WORKSPACE],
    shortName: SALES_WORKSPACE
  }, DEFAULT_VALUES),
  [LEADS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[LEADS],
    productApiNames: FEATURE_PRODUCT_MAP[LEADS],
    descriptions: FEATURE_DESCRIPTION_MAP[LEADS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[LEADS],
    shortName: LEADS
  }, DEFAULT_VALUES),
  [GUIDED_ACTIONS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[GUIDED_ACTIONS],
    productApiNames: FEATURE_PRODUCT_MAP[GUIDED_ACTIONS],
    descriptions: FEATURE_DESCRIPTION_MAP[GUIDED_ACTIONS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[GUIDED_ACTIONS],
    shortName: GUIDED_ACTIONS
  }, DEFAULT_VALUES),
  [SEQUENCES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SEQUENCES],
    productApiNames: FEATURE_PRODUCT_MAP[SEQUENCES],
    descriptions: FEATURE_DESCRIPTION_MAP[SEQUENCES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SEQUENCES],
    shortName: SEQUENCES
  }, DEFAULT_VALUES),
  [DYNAMIC_SEQUENCES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DYNAMIC_SEQUENCES],
    productApiNames: FEATURE_PRODUCT_MAP[DYNAMIC_SEQUENCES],
    descriptions: FEATURE_DESCRIPTION_MAP[DYNAMIC_SEQUENCES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DYNAMIC_SEQUENCES],
    shortName: DYNAMIC_SEQUENCES
  }, DEFAULT_VALUES),
  [TARGET_ACCOUNTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[TARGET_ACCOUNTS],
    productApiNames: FEATURE_PRODUCT_MAP[TARGET_ACCOUNTS],
    descriptions: FEATURE_DESCRIPTION_MAP[TARGET_ACCOUNTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[TARGET_ACCOUNTS],
    shortName: TARGET_ACCOUNTS
  }, DEFAULT_VALUES),
  [ABM_TOOLS_AND_AUTOMATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[ABM_TOOLS_AND_AUTOMATION],
    productApiNames: FEATURE_PRODUCT_MAP[ABM_TOOLS_AND_AUTOMATION],
    descriptions: FEATURE_DESCRIPTION_MAP[ABM_TOOLS_AND_AUTOMATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[ABM_TOOLS_AND_AUTOMATION],
    shortName: ABM_TOOLS_AND_AUTOMATION
  }, DEFAULT_VALUES),
  [TARGET_ACCOUNTS_OVERVIEW]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[TARGET_ACCOUNTS_OVERVIEW],
    productApiNames: FEATURE_PRODUCT_MAP[TARGET_ACCOUNTS_OVERVIEW],
    descriptions: FEATURE_DESCRIPTION_MAP[TARGET_ACCOUNTS_OVERVIEW],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[TARGET_ACCOUNTS_OVERVIEW],
    shortName: TARGET_ACCOUNTS_OVERVIEW
  }, DEFAULT_VALUES),
  [BREEZE_COPILOT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[BREEZE_COPILOT],
    productApiNames: FEATURE_PRODUCT_MAP[BREEZE_COPILOT],
    descriptions: FEATURE_DESCRIPTION_MAP[BREEZE_COPILOT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[BREEZE_COPILOT],
    shortName: BREEZE_COPILOT
  }, DEFAULT_VALUES),
  [DEALS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DEALS],
    productApiNames: FEATURE_PRODUCT_MAP[DEALS],
    descriptions: FEATURE_DESCRIPTION_MAP[DEALS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DEALS],
    shortName: DEALS
  }, DEFAULT_VALUES),
  [DEAL_PIPELINE_AUTOMATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DEAL_PIPELINE_AUTOMATION],
    productApiNames: FEATURE_PRODUCT_MAP[DEAL_PIPELINE_AUTOMATION],
    descriptions: FEATURE_DESCRIPTION_MAP[DEAL_PIPELINE_AUTOMATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DEAL_PIPELINE_AUTOMATION],
    shortName: DEAL_PIPELINE_AUTOMATION
  }, DEFAULT_VALUES),
  [DEAL_TAGS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DEAL_TAGS],
    productApiNames: FEATURE_PRODUCT_MAP[DEAL_TAGS],
    descriptions: FEATURE_DESCRIPTION_MAP[DEAL_TAGS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DEAL_TAGS],
    shortName: DEAL_TAGS
  }, DEFAULT_VALUES),
  [CUSTOM_DEAL_TAG_RULES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_DEAL_TAG_RULES],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_DEAL_TAG_RULES],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_DEAL_TAG_RULES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_DEAL_TAG_RULES],
    shortName: CUSTOM_DEAL_TAG_RULES
  }, DEFAULT_VALUES),
  [DEAL_SUMMARIES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DEAL_SUMMARIES],
    productApiNames: FEATURE_PRODUCT_MAP[DEAL_SUMMARIES],
    descriptions: FEATURE_DESCRIPTION_MAP[DEAL_SUMMARIES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DEAL_SUMMARIES],
    shortName: DEAL_SUMMARIES
  }, DEFAULT_VALUES),
  [DEAL_SPLITS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DEAL_SPLITS],
    productApiNames: FEATURE_PRODUCT_MAP[DEAL_SPLITS],
    descriptions: FEATURE_DESCRIPTION_MAP[DEAL_SPLITS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DEAL_SPLITS],
    shortName: DEAL_SPLITS
  }, DEFAULT_VALUES),
  [DEAL_APPROVALS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DEAL_APPROVALS],
    productApiNames: FEATURE_PRODUCT_MAP[DEAL_APPROVALS],
    descriptions: FEATURE_DESCRIPTION_MAP[DEAL_APPROVALS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DEAL_APPROVALS],
    shortName: DEAL_APPROVALS
  }, DEFAULT_VALUES),
  [DOCUMENTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DOCUMENTS],
    productApiNames: FEATURE_PRODUCT_MAP[DOCUMENTS],
    descriptions: FEATURE_DESCRIPTION_MAP[DOCUMENTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DOCUMENTS],
    shortName: DOCUMENTS
  }, DEFAULT_VALUES),
  [HUBSPOT_MOBILE_APP]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[HUBSPOT_MOBILE_APP],
    productApiNames: FEATURE_PRODUCT_MAP[HUBSPOT_MOBILE_APP],
    descriptions: FEATURE_DESCRIPTION_MAP[HUBSPOT_MOBILE_APP],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[HUBSPOT_MOBILE_APP],
    shortName: HUBSPOT_MOBILE_APP
  }, DEFAULT_VALUES),
  [MOBILE_INBOX]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[MOBILE_INBOX],
    productApiNames: FEATURE_PRODUCT_MAP[MOBILE_INBOX],
    descriptions: FEATURE_DESCRIPTION_MAP[MOBILE_INBOX],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[MOBILE_INBOX],
    shortName: MOBILE_INBOX
  }, DEFAULT_VALUES),
  [PAYMENTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[PAYMENTS],
    productApiNames: FEATURE_PRODUCT_MAP[PAYMENTS],
    descriptions: FEATURE_DESCRIPTION_MAP[PAYMENTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[PAYMENTS],
    shortName: PAYMENTS
  }, DEFAULT_VALUES),
  [STRIPE_PAYMENT_PROCESSING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[STRIPE_PAYMENT_PROCESSING],
    productApiNames: FEATURE_PRODUCT_MAP[STRIPE_PAYMENT_PROCESSING],
    descriptions: FEATURE_DESCRIPTION_MAP[STRIPE_PAYMENT_PROCESSING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[STRIPE_PAYMENT_PROCESSING],
    shortName: STRIPE_PAYMENT_PROCESSING
  }, DEFAULT_VALUES),
  [PAYMENT_LINKS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[PAYMENT_LINKS],
    productApiNames: FEATURE_PRODUCT_MAP[PAYMENT_LINKS],
    descriptions: FEATURE_DESCRIPTION_MAP[PAYMENT_LINKS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[PAYMENT_LINKS],
    shortName: PAYMENT_LINKS
  }, DEFAULT_VALUES),
  [SUBSCRIPTIONS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SUBSCRIPTIONS],
    productApiNames: FEATURE_PRODUCT_MAP[SUBSCRIPTIONS],
    descriptions: FEATURE_DESCRIPTION_MAP[SUBSCRIPTIONS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SUBSCRIPTIONS],
    shortName: SUBSCRIPTIONS
  }, DEFAULT_VALUES),
  [B2B_CHECKOUT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[B2B_CHECKOUT],
    productApiNames: FEATURE_PRODUCT_MAP[B2B_CHECKOUT],
    descriptions: FEATURE_DESCRIPTION_MAP[B2B_CHECKOUT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[B2B_CHECKOUT],
    shortName: B2B_CHECKOUT
  }, DEFAULT_VALUES),
  [QUOTES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[QUOTES],
    productApiNames: FEATURE_PRODUCT_MAP[QUOTES],
    descriptions: FEATURE_DESCRIPTION_MAP[QUOTES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[QUOTES],
    shortName: QUOTES
  }, DEFAULT_VALUES),
  [E_SIGNATURE]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[E_SIGNATURE],
    productApiNames: FEATURE_PRODUCT_MAP[E_SIGNATURE],
    descriptions: FEATURE_DESCRIPTION_MAP[E_SIGNATURE],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[E_SIGNATURE],
    shortName: E_SIGNATURE
  }, DEFAULT_VALUES),
  [INVOICES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[INVOICES],
    productApiNames: FEATURE_PRODUCT_MAP[INVOICES],
    descriptions: FEATURE_DESCRIPTION_MAP[INVOICES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[INVOICES],
    shortName: INVOICES
  }, DEFAULT_VALUES),
  [REPORTING_DASHBOARDS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[REPORTING_DASHBOARDS],
    productApiNames: FEATURE_PRODUCT_MAP[REPORTING_DASHBOARDS],
    descriptions: FEATURE_DESCRIPTION_MAP[REPORTING_DASHBOARDS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[REPORTING_DASHBOARDS],
    shortName: REPORTING_DASHBOARDS
  }, DEFAULT_VALUES),
  [SALES_ANALYTICS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SALES_ANALYTICS],
    productApiNames: FEATURE_PRODUCT_MAP[SALES_ANALYTICS],
    descriptions: FEATURE_DESCRIPTION_MAP[SALES_ANALYTICS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SALES_ANALYTICS],
    shortName: SALES_ANALYTICS
  }, DEFAULT_VALUES),
  [CUSTOM_REPORT_BUILDER]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_REPORT_BUILDER],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_REPORT_BUILDER],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_REPORT_BUILDER],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_REPORT_BUILDER],
    shortName: CUSTOM_REPORT_BUILDER
  }, DEFAULT_VALUES),
  [DEAL_JOURNEY_ANALYTICS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DEAL_JOURNEY_ANALYTICS],
    productApiNames: FEATURE_PRODUCT_MAP[DEAL_JOURNEY_ANALYTICS],
    descriptions: FEATURE_DESCRIPTION_MAP[DEAL_JOURNEY_ANALYTICS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DEAL_JOURNEY_ANALYTICS],
    shortName: DEAL_JOURNEY_ANALYTICS
  }, DEFAULT_VALUES),
  [PRODUCTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[PRODUCTS],
    productApiNames: FEATURE_PRODUCT_MAP[PRODUCTS],
    descriptions: FEATURE_DESCRIPTION_MAP[PRODUCTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[PRODUCTS],
    shortName: PRODUCTS
  }, DEFAULT_VALUES),
  [GOALS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[GOALS],
    productApiNames: FEATURE_PRODUCT_MAP[GOALS],
    descriptions: FEATURE_DESCRIPTION_MAP[GOALS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[GOALS],
    shortName: GOALS
  }, DEFAULT_VALUES),
  [CUSTOM_GOALS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_GOALS],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_GOALS],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_GOALS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_GOALS],
    shortName: CUSTOM_GOALS
  }, DEFAULT_VALUES),
  [CONVERSATION_INTELLIGENCE]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CONVERSATION_INTELLIGENCE],
    productApiNames: FEATURE_PRODUCT_MAP[CONVERSATION_INTELLIGENCE],
    descriptions: FEATURE_DESCRIPTION_MAP[CONVERSATION_INTELLIGENCE],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CONVERSATION_INTELLIGENCE],
    shortName: CONVERSATION_INTELLIGENCE
  }, DEFAULT_VALUES),
  [COACHING_PLAYLISTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[COACHING_PLAYLISTS],
    productApiNames: FEATURE_PRODUCT_MAP[COACHING_PLAYLISTS],
    descriptions: FEATURE_DESCRIPTION_MAP[COACHING_PLAYLISTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[COACHING_PLAYLISTS],
    shortName: COACHING_PLAYLISTS
  }, DEFAULT_VALUES),
  [TRACKED_TERMS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[TRACKED_TERMS],
    productApiNames: FEATURE_PRODUCT_MAP[TRACKED_TERMS],
    descriptions: FEATURE_DESCRIPTION_MAP[TRACKED_TERMS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[TRACKED_TERMS],
    shortName: TRACKED_TERMS
  }, DEFAULT_VALUES),
  [FORECASTING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[FORECASTING],
    productApiNames: FEATURE_PRODUCT_MAP[FORECASTING],
    descriptions: FEATURE_DESCRIPTION_MAP[FORECASTING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[FORECASTING],
    shortName: FORECASTING
  }, DEFAULT_VALUES),
  [FORECAST_ACROSS_TEAM_HIERARCHIES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[FORECAST_ACROSS_TEAM_HIERARCHIES],
    productApiNames: FEATURE_PRODUCT_MAP[FORECAST_ACROSS_TEAM_HIERARCHIES],
    descriptions: FEATURE_DESCRIPTION_MAP[FORECAST_ACROSS_TEAM_HIERARCHIES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[FORECAST_ACROSS_TEAM_HIERARCHIES],
    shortName: FORECAST_ACROSS_TEAM_HIERARCHIES
  }, DEFAULT_VALUES),
  [AI_FORECASTING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[AI_FORECASTING],
    productApiNames: FEATURE_PRODUCT_MAP[AI_FORECASTING],
    descriptions: FEATURE_DESCRIPTION_MAP[AI_FORECASTING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[AI_FORECASTING],
    shortName: AI_FORECASTING
  }, DEFAULT_VALUES),
  [PLAYBOOKS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[PLAYBOOKS],
    productApiNames: FEATURE_PRODUCT_MAP[PLAYBOOKS],
    descriptions: FEATURE_DESCRIPTION_MAP[PLAYBOOKS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[PLAYBOOKS],
    shortName: PLAYBOOKS
  }, DEFAULT_VALUES),
  [EMBED_AND_UPDATE_PROPERTIES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[EMBED_AND_UPDATE_PROPERTIES],
    productApiNames: FEATURE_PRODUCT_MAP[EMBED_AND_UPDATE_PROPERTIES],
    descriptions: FEATURE_DESCRIPTION_MAP[EMBED_AND_UPDATE_PROPERTIES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[EMBED_AND_UPDATE_PROPERTIES],
    shortName: EMBED_AND_UPDATE_PROPERTIES
  }, DEFAULT_VALUES),
  [CALCULATED_PROPERTIES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CALCULATED_PROPERTIES],
    productApiNames: FEATURE_PRODUCT_MAP[CALCULATED_PROPERTIES],
    descriptions: FEATURE_DESCRIPTION_MAP[CALCULATED_PROPERTIES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CALCULATED_PROPERTIES],
    shortName: CALCULATED_PROPERTIES
  }, DEFAULT_VALUES),
  [SYNC_PROPERTIES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SYNC_PROPERTIES],
    productApiNames: FEATURE_PRODUCT_MAP[SYNC_PROPERTIES],
    descriptions: FEATURE_DESCRIPTION_MAP[SYNC_PROPERTIES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SYNC_PROPERTIES],
    shortName: SYNC_PROPERTIES
  }, DEFAULT_VALUES),
  [SCORE_PROPERTIES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SCORE_PROPERTIES],
    productApiNames: FEATURE_PRODUCT_MAP[SCORE_PROPERTIES],
    descriptions: FEATURE_DESCRIPTION_MAP[SCORE_PROPERTIES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SCORE_PROPERTIES],
    shortName: SCORE_PROPERTIES
  }, DEFAULT_VALUES),
  [PREDICTIVE_LEAD_SCORING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[PREDICTIVE_LEAD_SCORING],
    productApiNames: FEATURE_PRODUCT_MAP[PREDICTIVE_LEAD_SCORING],
    descriptions: FEATURE_DESCRIPTION_MAP[PREDICTIVE_LEAD_SCORING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[PREDICTIVE_LEAD_SCORING],
    shortName: PREDICTIVE_LEAD_SCORING
  }, DEFAULT_VALUES),
  [FIELD_LEVEL_PERMISSIONS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[FIELD_LEVEL_PERMISSIONS],
    productApiNames: FEATURE_PRODUCT_MAP[FIELD_LEVEL_PERMISSIONS],
    descriptions: FEATURE_DESCRIPTION_MAP[FIELD_LEVEL_PERMISSIONS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[FIELD_LEVEL_PERMISSIONS],
    shortName: FIELD_LEVEL_PERMISSIONS
  }, DEFAULT_VALUES),
  [DATA_MODEL]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DATA_MODEL],
    productApiNames: FEATURE_PRODUCT_MAP[DATA_MODEL],
    descriptions: FEATURE_DESCRIPTION_MAP[DATA_MODEL],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DATA_MODEL],
    shortName: DATA_MODEL
  }, DEFAULT_VALUES),
  [ASSOCIATION_LABELS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[ASSOCIATION_LABELS],
    productApiNames: FEATURE_PRODUCT_MAP[ASSOCIATION_LABELS],
    descriptions: FEATURE_DESCRIPTION_MAP[ASSOCIATION_LABELS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[ASSOCIATION_LABELS],
    shortName: ASSOCIATION_LABELS
  }, DEFAULT_VALUES),
  [CUSTOM_USER_PERMISSIONS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_USER_PERMISSIONS],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_USER_PERMISSIONS],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_USER_PERMISSIONS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_USER_PERMISSIONS],
    shortName: CUSTOM_USER_PERMISSIONS
  }, DEFAULT_VALUES),
  [PERMISSION_SETS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[PERMISSION_SETS],
    productApiNames: FEATURE_PRODUCT_MAP[PERMISSION_SETS],
    descriptions: FEATURE_DESCRIPTION_MAP[PERMISSION_SETS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[PERMISSION_SETS],
    shortName: PERMISSION_SETS
  }, DEFAULT_VALUES),
  [CUSTOM_PERMISSION_SETS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_PERMISSION_SETS],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_PERMISSION_SETS],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_PERMISSION_SETS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_PERMISSION_SETS],
    shortName: CUSTOM_PERMISSION_SETS
  }, DEFAULT_VALUES),
  [SLACK_INTEGRATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SLACK_INTEGRATION],
    productApiNames: FEATURE_PRODUCT_MAP[SLACK_INTEGRATION],
    descriptions: FEATURE_DESCRIPTION_MAP[SLACK_INTEGRATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SLACK_INTEGRATION],
    shortName: SLACK_INTEGRATION
  }, DEFAULT_VALUES),
  [USER_MANAGEMENT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[USER_MANAGEMENT],
    productApiNames: FEATURE_PRODUCT_MAP[USER_MANAGEMENT],
    descriptions: FEATURE_DESCRIPTION_MAP[USER_MANAGEMENT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[USER_MANAGEMENT],
    shortName: USER_MANAGEMENT
  }, DEFAULT_VALUES),
  [TEAMS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[TEAMS],
    productApiNames: FEATURE_PRODUCT_MAP[TEAMS],
    descriptions: FEATURE_DESCRIPTION_MAP[TEAMS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[TEAMS],
    shortName: TEAMS
  }, DEFAULT_VALUES),
  [PRESETS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[PRESETS],
    productApiNames: FEATURE_PRODUCT_MAP[PRESETS],
    descriptions: FEATURE_DESCRIPTION_MAP[PRESETS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[PRESETS],
    shortName: PRESETS
  }, DEFAULT_VALUES),
  [ORGANIZE_TEAMS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[ORGANIZE_TEAMS],
    productApiNames: FEATURE_PRODUCT_MAP[ORGANIZE_TEAMS],
    descriptions: FEATURE_DESCRIPTION_MAP[ORGANIZE_TEAMS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[ORGANIZE_TEAMS],
    shortName: ORGANIZE_TEAMS
  }, DEFAULT_VALUES),
  [LOG_IN_AS_ANOTHER_USER]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[LOG_IN_AS_ANOTHER_USER],
    productApiNames: FEATURE_PRODUCT_MAP[LOG_IN_AS_ANOTHER_USER],
    descriptions: FEATURE_DESCRIPTION_MAP[LOG_IN_AS_ANOTHER_USER],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[LOG_IN_AS_ANOTHER_USER],
    shortName: LOG_IN_AS_ANOTHER_USER
  }, DEFAULT_VALUES),
  [SINGLE_SIGN_ON]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SINGLE_SIGN_ON],
    productApiNames: FEATURE_PRODUCT_MAP[SINGLE_SIGN_ON],
    descriptions: FEATURE_DESCRIPTION_MAP[SINGLE_SIGN_ON],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SINGLE_SIGN_ON],
    shortName: SINGLE_SIGN_ON
  }, DEFAULT_VALUES),
  [ONE_TO_ONE_TECHNICAL_SUPPORT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[ONE_TO_ONE_TECHNICAL_SUPPORT],
    productApiNames: FEATURE_PRODUCT_MAP[ONE_TO_ONE_TECHNICAL_SUPPORT],
    descriptions: FEATURE_DESCRIPTION_MAP[ONE_TO_ONE_TECHNICAL_SUPPORT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[ONE_TO_ONE_TECHNICAL_SUPPORT],
    shortName: ONE_TO_ONE_TECHNICAL_SUPPORT
  }, DEFAULT_VALUES),
  [EMAIL_AND_IN_APP_CHAT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[EMAIL_AND_IN_APP_CHAT],
    productApiNames: FEATURE_PRODUCT_MAP[EMAIL_AND_IN_APP_CHAT],
    descriptions: FEATURE_DESCRIPTION_MAP[EMAIL_AND_IN_APP_CHAT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[EMAIL_AND_IN_APP_CHAT],
    shortName: EMAIL_AND_IN_APP_CHAT
  }, DEFAULT_VALUES),
  [PHONE_SUPPORT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[PHONE_SUPPORT],
    productApiNames: FEATURE_PRODUCT_MAP[PHONE_SUPPORT],
    descriptions: FEATURE_DESCRIPTION_MAP[PHONE_SUPPORT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[PHONE_SUPPORT],
    shortName: PHONE_SUPPORT
  }, DEFAULT_VALUES),
  [LISTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[LISTS],
    productApiNames: FEATURE_PRODUCT_MAP[LISTS],
    descriptions: FEATURE_DESCRIPTION_MAP[LISTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[LISTS],
    shortName: LISTS
  }, DEFAULT_VALUES),
  [ADVANCED_LIST_CRITERIA]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[ADVANCED_LIST_CRITERIA],
    productApiNames: FEATURE_PRODUCT_MAP[ADVANCED_LIST_CRITERIA],
    descriptions: FEATURE_DESCRIPTION_MAP[ADVANCED_LIST_CRITERIA],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[ADVANCED_LIST_CRITERIA],
    shortName: ADVANCED_LIST_CRITERIA
  }, DEFAULT_VALUES),
  [MULTIPLE_CURRENCIES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[MULTIPLE_CURRENCIES],
    productApiNames: FEATURE_PRODUCT_MAP[MULTIPLE_CURRENCIES],
    descriptions: FEATURE_DESCRIPTION_MAP[MULTIPLE_CURRENCIES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[MULTIPLE_CURRENCIES],
    shortName: MULTIPLE_CURRENCIES
  }, DEFAULT_VALUES),
  [DUPLICATE_MANAGEMENT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[DUPLICATE_MANAGEMENT],
    productApiNames: FEATURE_PRODUCT_MAP[DUPLICATE_MANAGEMENT],
    descriptions: FEATURE_DESCRIPTION_MAP[DUPLICATE_MANAGEMENT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[DUPLICATE_MANAGEMENT],
    shortName: DUPLICATE_MANAGEMENT
  }, DEFAULT_VALUES),
  [LINKEDIN_CRM_SYNC_INTEGRATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[LINKEDIN_CRM_SYNC_INTEGRATION],
    productApiNames: FEATURE_PRODUCT_MAP[LINKEDIN_CRM_SYNC_INTEGRATION],
    descriptions: FEATURE_DESCRIPTION_MAP[LINKEDIN_CRM_SYNC_INTEGRATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[LINKEDIN_CRM_SYNC_INTEGRATION],
    shortName: LINKEDIN_CRM_SYNC_INTEGRATION
  }, DEFAULT_VALUES),
  [SALES_EMAIL_FREQUENCY_CONTROLS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SALES_EMAIL_FREQUENCY_CONTROLS],
    productApiNames: FEATURE_PRODUCT_MAP[SALES_EMAIL_FREQUENCY_CONTROLS],
    descriptions: FEATURE_DESCRIPTION_MAP[SALES_EMAIL_FREQUENCY_CONTROLS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SALES_EMAIL_FREQUENCY_CONTROLS],
    shortName: SALES_EMAIL_FREQUENCY_CONTROLS
  }, DEFAULT_VALUES),
  [SALESFORCE_INTEGRATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SALESFORCE_INTEGRATION],
    productApiNames: FEATURE_PRODUCT_MAP[SALESFORCE_INTEGRATION],
    descriptions: FEATURE_DESCRIPTION_MAP[SALESFORCE_INTEGRATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SALESFORCE_INTEGRATION],
    shortName: SALESFORCE_INTEGRATION
  }, DEFAULT_VALUES),
  [SALESFORCE_CUSTOM_OBJECT_SYNC]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SALESFORCE_CUSTOM_OBJECT_SYNC],
    productApiNames: FEATURE_PRODUCT_MAP[SALESFORCE_CUSTOM_OBJECT_SYNC],
    descriptions: FEATURE_DESCRIPTION_MAP[SALESFORCE_CUSTOM_OBJECT_SYNC],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SALESFORCE_CUSTOM_OBJECT_SYNC],
    shortName: SALESFORCE_CUSTOM_OBJECT_SYNC
  }, DEFAULT_VALUES),
  [WORKFLOWS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[WORKFLOWS],
    productApiNames: FEATURE_PRODUCT_MAP[WORKFLOWS],
    descriptions: FEATURE_DESCRIPTION_MAP[WORKFLOWS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[WORKFLOWS],
    shortName: WORKFLOWS
  }, DEFAULT_VALUES),
  [WORKFLOW_EXTENSIONS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[WORKFLOW_EXTENSIONS],
    productApiNames: FEATURE_PRODUCT_MAP[WORKFLOW_EXTENSIONS],
    descriptions: FEATURE_DESCRIPTION_MAP[WORKFLOW_EXTENSIONS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[WORKFLOW_EXTENSIONS],
    shortName: WORKFLOW_EXTENSIONS
  }, DEFAULT_VALUES),
  [AUTOMATIC_LEAD_ROTATION]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[AUTOMATIC_LEAD_ROTATION],
    productApiNames: FEATURE_PRODUCT_MAP[AUTOMATIC_LEAD_ROTATION],
    descriptions: FEATURE_DESCRIPTION_MAP[AUTOMATIC_LEAD_ROTATION],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[AUTOMATIC_LEAD_ROTATION],
    shortName: AUTOMATIC_LEAD_ROTATION
  }, DEFAULT_VALUES),
  [TRIGGER_SEQUENCES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[TRIGGER_SEQUENCES],
    productApiNames: FEATURE_PRODUCT_MAP[TRIGGER_SEQUENCES],
    descriptions: FEATURE_DESCRIPTION_MAP[TRIGGER_SEQUENCES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[TRIGGER_SEQUENCES],
    shortName: TRIGGER_SEQUENCES
  }, DEFAULT_VALUES),
  [WORKFLOW_HEALTH_MONITORING]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[WORKFLOW_HEALTH_MONITORING],
    productApiNames: FEATURE_PRODUCT_MAP[WORKFLOW_HEALTH_MONITORING],
    descriptions: FEATURE_DESCRIPTION_MAP[WORKFLOW_HEALTH_MONITORING],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[WORKFLOW_HEALTH_MONITORING],
    shortName: WORKFLOW_HEALTH_MONITORING
  }, DEFAULT_VALUES),
  [CUSTOM_EVENTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_EVENTS],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_EVENTS],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_EVENTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_EVENTS],
    shortName: CUSTOM_EVENTS
  }, DEFAULT_VALUES),
  [CUSTOM_OBJECTS]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_OBJECTS],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_OBJECTS],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_OBJECTS],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_OBJECTS],
    shortName: CUSTOM_OBJECTS
  }, DEFAULT_VALUES),
  [CUSTOM_PROPERTIES]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[CUSTOM_PROPERTIES],
    productApiNames: FEATURE_PRODUCT_MAP[CUSTOM_PROPERTIES],
    descriptions: FEATURE_DESCRIPTION_MAP[CUSTOM_PROPERTIES],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[CUSTOM_PROPERTIES],
    shortName: CUSTOM_PROPERTIES
  }, DEFAULT_VALUES),
  [SENSITIVE_DATA]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[SENSITIVE_DATA],
    productApiNames: FEATURE_PRODUCT_MAP[SENSITIVE_DATA],
    descriptions: FEATURE_DESCRIPTION_MAP[SENSITIVE_DATA],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[SENSITIVE_DATA],
    shortName: SENSITIVE_DATA
  }, DEFAULT_VALUES),
  [STANDARD_SANDBOX_ACCOUNT]: Object.assign({
    displayName: FEATURE_DISPLAY_NAME_MAP[STANDARD_SANDBOX_ACCOUNT],
    productApiNames: FEATURE_PRODUCT_MAP[STANDARD_SANDBOX_ACCOUNT],
    descriptions: FEATURE_DESCRIPTION_MAP[STANDARD_SANDBOX_ACCOUNT],
    shortLimits: FEATURE_SHORT_LIMIT_MAP[STANDARD_SANDBOX_ACCOUNT],
    shortName: STANDARD_SANDBOX_ACCOUNT
  }, DEFAULT_VALUES)
};